import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/icons';

export const CardEventIcon: GPTGameIcon = (props) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3026_521)">
      <path
        d="M15.99 22.36C15.6 22.92 15.28 23.26 15.07 23.3C15.07 23.3 15.07 23.3 15.05 23.3C14.93 23.31 14.74 23.3 14.51 23.25C14.5 23.25 14.49 23.25 14.47 23.25C13.45 23.04 11.55 22.33 9.59999 21.48C9.55999 21.46 9.51999 21.44 9.47999 21.43C7.53999 20.58 5.56999 19.59 4.38999 18.83C3.79999 18.45 3.40999 18.13 3.31999 17.9C3.29999 17.85 3.28999 17.78 3.28999 17.68C3.23999 15.55 8.14999 3.06 9.21999 2.68C10.21 2.33 13.18 3.25 16.05 4.44L16.28 4.54C19.32 5.82 22.19 7.37 22.37 7.95C22.66 8.93 18.22 19.2 16.01 22.38L15.99 22.36Z"
        fill="#868686"
      />
      <path
        d="M14.88 22.3C14.59 22.67 14.35 22.9 14.19 22.93C14.05 22.95 13.84 22.93 13.56 22.87C12.69 22.69 11.21 22.16 9.60999 21.48C9.56999 21.46 9.52999 21.44 9.48999 21.43C6.81999 20.31 3.83999 18.81 2.79999 17.94C2.60999 17.78 2.48999 17.64 2.43999 17.53C2.07999 16.66 4.58999 9.67 6.49999 5.47C7.29999 3.7 7.99999 2.43 8.32999 2.31C9.41999 1.92 12.93 3.09 16.05 4.45L16.28 4.55C18.97 5.74 21.32 7.05 21.48 7.58C21.78 8.6 17.01 19.57 14.9 22.32L14.88 22.3Z"
        fill="white"
      />
      <path
        d="M9.72 2.29C9.72 2.29 16.21 3.76 21.46 7.55L22.35 7.93C22.35 7.93 22.12 7.18 19.14 5.64C17.3 4.69 13.87 3.12 9.72 2.29Z"
        fill="white"
      />
      <path
        d="M15.07 23.3C15.07 23.3 15.07 23.3 15.05 23.3C14.99 23.3 14.82 23.3 14.51 23.25C14.5 23.25 14.49 23.25 14.47 23.25C13.66 23.12 11.92 22.67 8.67 21.21C3.86 19.05 2.84 17.99 2.78 17.93C2.78 17.93 3.39 18.29 4.38 18.82C5.76 19.57 7.87 20.65 10.08 21.55C10.26 21.63 10.43 21.69 10.6 21.76C11.47 22.11 12.19 22.38 12.77 22.59H12.78C13.07 22.7 13.32 22.79 13.55 22.86C14.65 23.23 15.07 23.3 15.07 23.3Z"
        fill="#898989"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.3">
        <path
          d="M8.85999 3C7.73999 3.12 4.97999 11.3 5.54999 14.49C6.11999 17.68 16.43 15.8 18.49 13.8C20.55 11.79 20.5 8.01 19.49 6.71C18.48 5.41 10.08 2.87 8.85999 3Z"
          fill="#F5F5F5"
        />
      </g>
      <g style={{ mixBlendMode: 'overlay' }} opacity="0.3">
        <path
          d="M6.99 20.11C4.98 18.46 15.86 17.32 16.74 17.36C17.62 17.4 15.07 22.4 14.23 22.83C13.39 23.26 6.99 20.11 6.99 20.11Z"
          fill="#F6F6F6"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
        <path
          d="M21.88 7.73C21.66 7.63 20.33 11.72 18.21 16.3C16.09 20.88 15.48 21.71 15.63 21.99C15.79 22.26 18.68 17.82 20.16 14.19C21.64 10.56 22.37 8.2 22.28 8.08C22.19 7.97 21.88 7.72 21.88 7.72V7.73Z"
          fill="#DFDFDF"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
        <path
          d="M15.99 22.37C15.6 22.93 15.28 23.27 15.07 23.31C15.07 23.31 15.07 23.31 15.05 23.31C14.93 23.32 14.74 23.31 14.51 23.26C14.5 23.26 14.49 23.26 14.47 23.26C13.66 23.13 11.92 22.68 8.67 21.22C3.86 19.06 2.84 18 2.78 17.94C2.59 17.78 2.47 17.64 2.42 17.53C2.06 16.66 4.57 9.67 6.48 5.47C5.74 7.34 2.8 14.88 2.75 16.59C2.74 16.94 2.93 17.31 3.27 17.69C3.99 18.5 5.38 19.35 6.96 20.1C7.68 20.44 8.44 20.77 9.19 21.07C11.21 21.87 13.42 22.18 14.76 22.3C14.8 22.3 14.83 22.3 14.87 22.3C15.52 22.36 15.94 22.37 15.98 22.37H15.99Z"
          fill="#FCFCFC"
        />
      </g>
      <path
        d="M17.62 5.38C16.29 4.92 16.7 6.89 17.55 7.94C18.41 8.99 20.25 7.43 20.55 7.17C20.85 6.91 18.42 5.66 17.61 5.39L17.62 5.38Z"
        fill="#F6F6F6"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.78">
        <path
          d="M2.80999 18.36C2.80999 18.36 7.60999 20.35 11.76 20.88C16.27 21.46 16.5 20.49 17.1 18.43C17.49 17.07 18.95 8.21 19.04 6.89C19.13 5.57 18.69 5.38 18.69 5.38L2.79999 17.83V18.36H2.80999Z"
          fill="#555555"
        />
      </g>
      <path
        d="M16.19 18.99C15.96 19.63 15.73 20.04 15.53 20.13C15.53 20.13 15.53 20.13 15.51 20.13C15.39 20.18 15.21 20.21 14.97 20.22C14.96 20.22 14.95 20.22 14.93 20.22C13.89 20.28 11.87 20.06 9.76999 19.72C9.72999 19.72 9.67999 19.71 9.63999 19.7C7.54998 19.36 5.38999 18.89 4.05998 18.46C3.38998 18.24 2.92998 18.02 2.78998 17.83C2.75998 17.79 2.72999 17.72 2.69999 17.63C2.11999 15.58 3.73998 2.26 4.67998 1.62C5.54998 1.03 8.65998 1.18 11.74 1.62L11.98 1.66C15.25 2.14 18.41 2.91 18.73 3.44C19.26 4.32 17.53 15.37 16.19 19V18.99Z"
        fill="#BBBBBB"
      />
      <path
        d="M15.1 19.2C14.92 19.63 14.74 19.91 14.58 19.98C14.45 20.03 14.24 20.07 13.95 20.08C13.06 20.12 11.5 19.98 9.78 19.73C9.74 19.73 9.69 19.72 9.65 19.71C6.78 19.29 3.52 18.59 2.3 18C2.08 17.89 1.92 17.79 1.85 17.69C1.28 16.94 1.97 9.54 2.76 4.99C3.1 3.08 3.45 1.67 3.74 1.47C4.7 0.82 8.39 1.07 11.75 1.61L11.99 1.65C14.9 2.13 17.5 2.81 17.78 3.28C18.33 4.19 16.46 16 15.1 19.2Z"
        fill="url(#paint0_linear_3026_521)"
      />
      <path
        d="M5.08999 1.13C5.08999 1.13 11.74 0.93 17.77 3.28L18.72 3.43C18.72 3.43 18.31 2.76 15.04 2.02C13.02 1.56 9.30999 0.9 5.07999 1.13H5.08999Z"
        fill="#A8A8A8"
      />
      <path
        d="M15.53 20.13C15.53 20.13 15.53 20.13 15.51 20.13C15.45 20.15 15.29 20.19 14.97 20.22C14.96 20.22 14.95 20.22 14.93 20.22C14.11 20.29 12.32 20.3 8.81001 19.7C3.61001 18.81 2.36001 18.05 2.29001 18C2.29001 18 2.97001 18.2 4.06001 18.46C5.58001 18.84 7.90001 19.36 10.26 19.68C10.45 19.71 10.64 19.73 10.81 19.75C11.74 19.87 12.5 19.95 13.12 20.01H13.13C13.43 20.04 13.7 20.06 13.94 20.08C15.1 20.16 15.52 20.13 15.52 20.13H15.53Z"
        fill="#9B9B9B"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.3">
        <path
          d="M4.44 2.03C3.39 2.43 2.76 11.04 4.11 13.98C5.46 16.93 14.97 12.53 16.47 10.07C17.97 7.61 16.97 3.96 15.66 2.96C14.36 1.96 5.59 1.6 4.44 2.03Z"
          fill="#EFEFEF"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.36 8.09C15.36 8.09 14.08 7.77 12.83 9.26C12.96 9.5 13.01 9.83 12.94 10.18C12.81 10.77 12.38 11.18 11.97 11.08C11.56 10.98 11.33 10.42 11.45 9.82C11.53 9.42 11.75 9.11 12.01 8.98C11.83 8.2 11.44 7.16 10.64 6.22C9.54001 6.71 8.77001 7.47 8.29001 8.09C8.46001 8.33 8.53001 8.71 8.45001 9.1C8.32001 9.69 7.89001 10.1 7.48001 10C7.07001 9.9 6.84001 9.34 6.96001 8.74C7.03001 8.39 7.22001 8.1 7.44001 7.95C6.91001 6.04 5.63001 5.74 5.63001 5.74C6.46001 9.03 5.35001 12.4 5.35001 12.4L9.14001 13.33L12.93 14.26C12.93 14.26 13.28 10.71 15.35 8.13L15.36 8.09Z"
        fill="url(#paint1_linear_3026_521)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.55001 9.99C7.55001 9.99 7.51001 9.99 7.49001 9.98C7.08001 9.88 6.85001 9.32 6.97001 8.72C7.04001 8.37 7.23001 8.08 7.45001 7.93C7.02001 6.38 6.08001 5.85 5.64001 5.71L5.76002 5.74C5.76002 5.74 7.04001 6.04 7.57001 7.95C7.35001 8.1 7.16001 8.39 7.09001 8.74C6.97001 9.31 7.17001 9.84 7.55001 9.98V9.99Z"
        fill="url(#paint2_linear_3026_521)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.93 11.06C11.93 11.06 11.97 11.07 11.99 11.08C12.4 11.18 12.84 10.78 12.96 10.18C13.03 9.83 12.98 9.49 12.84 9.25C13.85 8.05 14.92 8.01 15.36 8.09L15.24 8.06C15.24 8.06 13.96 7.74 12.72 9.22C12.86 9.46 12.91 9.8 12.84 10.15C12.72 10.72 12.32 11.11 11.93 11.06Z"
        fill="url(#paint3_linear_3026_521)"
      />
      <g filter="url(#filter0_d_3026_521)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.11 14.11C13.18 13.77 11.48 13.06 9.31 12.53C7.14 12 5.32 11.85 5.25 12.19L5.19 12.47L5.61 12.57C6.22 12.93 7.51 13.39 9.04 13.76C10.57 14.13 11.93 14.32 12.62 14.28L13.04 14.38L13.1 14.1L13.11 14.11Z"
          fill="url(#paint4_linear_3026_521)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.06 14.39C12.99 14.73 11.17 14.58 8.99999 14.05C6.82999 13.52 5.12999 12.81 5.19999 12.47C5.26999 12.13 7.08999 12.28 9.25999 12.81C11.43 13.34 13.13 14.05 13.06 14.39Z"
        fill="url(#paint5_linear_3026_521)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9 14.38C12.85 14.63 11.11 14.43 9.02 13.92C6.93 13.41 5.27999 12.79 5.32999 12.53C5.37999 12.27 7.12 12.48 9.21 12.99C11.3 13.5 12.95 14.12 12.9 14.38Z"
        fill="url(#paint6_linear_3026_521)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <g filter="url(#filter1_d_3026_521)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.57001 11.18C5.64001 10.84 7.41001 10.99 9.53001 11.51C11.64 12.03 13.29 12.73 13.23 13.08L13.29 12.8C13.36 12.46 11.7 11.76 9.59001 11.23C7.48001 10.7 5.71001 10.56 5.63001 10.9L5.57001 11.18Z"
          fill="url(#paint7_linear_3026_521)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.53001 11.51C7.42001 10.98 5.65001 10.84 5.57001 11.18C5.57001 11.22 5.57001 11.27 5.62001 11.32C5.68001 11.21 5.78001 11.12 5.93001 11.14C6.46001 11.08 7.85001 11.29 9.48001 11.69C11.16 12.11 12.54 12.6 12.94 12.9C12.96 12.91 12.98 12.92 12.99 12.94C13 12.95 13.01 12.96 13.02 12.97C13.07 13.03 13.1 13.1 13.11 13.18C13.17 13.15 13.21 13.12 13.21 13.07C13.28 12.73 11.62 12.03 9.51001 11.5L9.53001 11.51Z"
        fill="url(#paint8_linear_3026_521)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        opacity="0.8"
        d="M10.78 6.71C9.89001 6.23 10.66 8.16 11.16 8.25C11.66 8.34 11.51 7.11 10.78 6.71Z"
        fill="white"
      />
      <g style={{ mixBlendMode: 'overlay' }} opacity="0.3">
        <path
          d="M6.92 19.06C4.56 17.97 14.81 14.14 15.67 13.96C16.53 13.77 15.31 19.26 14.61 19.88C13.91 20.5 6.92 19.06 6.92 19.06Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          d="M18.23 3.35C17.99 3.31 17.73 7.6 16.82 12.56C15.91 17.53 15.53 18.48 15.75 18.71C15.97 18.94 17.66 13.91 18.18 10.03C18.7 6.15 18.82 3.68 18.7 3.59C18.59 3.5 18.22 3.35 18.22 3.35H18.23Z"
          fill="#90847F"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
        <path
          d="M16.19 18.99C15.96 19.63 15.73 20.04 15.53 20.13C15.53 20.13 15.53 20.13 15.51 20.13C15.39 20.18 15.21 20.21 14.97 20.22C14.96 20.22 14.95 20.22 14.93 20.22C14.11 20.29 12.32 20.3 8.80999 19.7C3.60999 18.81 2.35999 18.05 2.28999 18C2.06999 17.89 1.90999 17.79 1.83999 17.69C1.26999 16.94 1.95999 9.54 2.74999 4.99C2.49999 6.98 1.53999 15.02 1.92999 16.69C2.00999 17.03 2.28999 17.35 2.70999 17.63C3.60999 18.23 5.16999 18.7 6.87999 19.04C7.65999 19.19 8.47999 19.32 9.27999 19.42C11.44 19.69 13.66 19.44 14.98 19.22C15.02 19.22 15.05 19.21 15.09 19.2C15.74 19.09 16.14 19 16.18 18.99H16.19Z"
          fill="#464646"
        />
      </g>
      <path
        d="M13.52 2.14C12.12 2.03 13 3.84 14.1 4.63C15.19 5.43 16.59 3.46 16.81 3.13C17.04 2.8 14.37 2.21 13.52 2.14Z"
        fill="white"
      />
      <path
        d="M4.00086 5.05697L4.69876 1.38452L5.14347 1.46903L4.79725 3.29091L4.84028 3.29909L6.83624 1.79072L7.41724 1.90113L5.56022 3.26497L6.71934 5.57358L6.18138 5.47135L5.22904 3.5216L4.67184 3.95081L4.44557 5.14148L4.00086 5.05697Z"
        fill="black"
      />
      <path
        d="M11.3864 18.6365L11.8439 14.9264L12.2932 14.9818L12.0662 16.8223L12.1097 16.8277L14.0033 15.1927L14.5902 15.265L12.8259 16.7468L14.1327 18.9751L13.5893 18.9081L12.5121 17.0244L11.984 17.489L11.8357 18.6919L11.3864 18.6365Z"
        fill="black"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3026_521"
        x="-9.81"
        y="2.00818"
        width="27.9221"
        height="22.3718"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_521" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_521"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3026_521"
        x="-9.42999"
        y="0.715163"
        width="27.7221"
        height="22.3648"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_521" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_521"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3026_521"
        x1="8.15"
        y1="19.47"
        x2="10.9"
        y2="1.48"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#DFDFDF" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3026_521"
        x1="4.96218"
        y1="8.71411"
        x2="14.7246"
        y2="10.9267"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FADA40" />
        <stop offset="0.03" stop-color="#F1C734" />
        <stop offset="0.12" stop-color="#DD9A18" />
        <stop offset="0.19" stop-color="#D07E06" />
        <stop offset="0.23" stop-color="#CC7400" />
        <stop offset="0.29" stop-color="#DC7C00" />
        <stop offset="0.34" stop-color="#EC8500" />
        <stop offset="0.39" stop-color="#EE950C" />
        <stop offset="0.47" stop-color="#F5C12D" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.71" stop-color="#FFFBE2" />
        <stop offset="0.73" stop-color="#FDF3C5" />
        <stop offset="0.78" stop-color="#FBE699" />
        <stop offset="0.82" stop-color="#F9DC74" />
        <stop offset="0.87" stop-color="#F8D558" />
        <stop offset="0.91" stop-color="#F7CF44" />
        <stop offset="0.96" stop-color="#F7CC38" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3026_521"
        x1="6.40599"
        y1="5.64636"
        x2="7.46063"
        y2="10.2051"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FCE3A1" />
        <stop offset="0.07" stop-color="#FCDF8B" />
        <stop offset="0.18" stop-color="#FCD96F" />
        <stop offset="0.25" stop-color="#FDD865" />
        <stop offset="0.48" stop-color="#FDE19B" />
        <stop offset="0.83" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3026_521"
        x1="14.7118"
        y1="7.69346"
        x2="11.8776"
        y2="11.251"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.24" stop-color="#FCE3A1" />
        <stop offset="0.28" stop-color="#FCDF8B" />
        <stop offset="0.34" stop-color="#FCD96F" />
        <stop offset="0.38" stop-color="#FDD865" />
        <stop offset="0.55" stop-color="#FFEBA8" />
        <stop offset="0.72" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3026_521"
        x1="3.91375"
        y1="12.5256"
        x2="13.1007"
        y2="14.6078"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3026_521"
        x1="5.16926"
        y1="12.5959"
        x2="13.0592"
        y2="14.3841"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3026_521"
        x1="5.30094"
        y1="12.6483"
        x2="12.908"
        y2="14.3724"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3026_521"
        x1="4.27771"
        y1="11.593"
        x2="13.3523"
        y2="12.3949"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3026_521"
        x1="5.52198"
        y1="11.713"
        x2="13.2817"
        y2="12.3987"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <clipPath id="clip0_3026_521">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
